import { render } from "./GradingScale.vue?vue&type=template&id=1f24ad3a&lang=true"
import script from "./GradingScale.vue?vue&type=script&lang=js"
export * from "./GradingScale.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__